import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import ButtonInPhieu from '../../../component/button-in-phieu'
import { ConfirmDialog } from '../../../component/ConfirmDialog'
import CustomTabMenu from '../../../component/CustomTabMenu'
import DanhSachPhieu from '../../../component/DanhSachPhieu'
import InputSearch from '../../../component/InputSearch'
import LabelRequired from '../../../component/LabelRequired'
import { TableCustom } from '../../../component/table/table-custom/TableCustom'
import { columnsDanhSachDonThuoc } from '../../../phan-he-kham-benh/columns/tab-thuoc/ColumnTabThuoc'
import { thuocVatTuColumn, vatTuColumn } from '../../../phan-he-kham-benh/constants/Columns'
import { WORKFLOW_MEDICAL_ITEM_STATUS_CODE } from '../../../phan-he-kham-benh/constants/Thuoc'
import PageKeThuoc from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/PageKeThuoc'
import ModalKeVatTu from '../../../phan-he-kham-benh/modals/modal-ke-vat-tu/ModalKeVatTu'
import { IInPhieuChiDinhThuocParams } from '../../../phan-he-kham-benh/models/ThuocModels'
import { deleteDonThuoc, getDetailDonThuoc, getDonThuocDVKT, getDsThuocVatTuDVKT, huyGuiDonThuoc, printPhieuChiDinhThuoc, saveDonThuocDVKT } from '../../../phan-he-kham-benh/services/ThuocService'
import { APP_DATE_TIME_FORMAT, CODE, KEY, ORDER_TYPE_ID, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../utils/Constant'
import { formatDateTime, getErrorMessage } from '../../../utils/FormatUtils'
import WfButton from '../../../workflows/components/WfButton'
import { WfConstTrackerClinical } from '../../../workflows/Constant'
import { TableCollapseCustom } from '../../../component/table/table-collapse/TableCollapseCustom'
import { getBirthdayDrugParam } from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/utils'

type Props = {
    handleClose: () => void
    generalInfo: any
}

const TYPE = {
    [ORDER_TYPE_ID.THUOC]: {
        columns: columnsDanhSachDonThuoc
    },
    [ORDER_TYPE_ID.VAT_TU]: {
        columns: vatTuColumn
    }
};

const ModalThuocVatTuTieuHao = ({
    handleClose, generalInfo
}: Props) => {
    const [isDetail, setIsDetail] = useState(false);

    const GENERAL_TABS = [
        {
            eventKey: '0',
            title: 'Thuốc/vật tư',
            component: <ThuocVatTu generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.THUOC} isReturn={false} />,
        },
        {
            eventKey: '1',
            title: 'Thuốc/vật tư hoàn trả',
            component: <ThuocVatTu generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.VAT_TU} isReturn={true} />,
        },
    ];

    const DETAIL_TABS = [
        {
            eventKey: '0',
            title: 'Thuốc',
            component: <ThuocVatTuDetail generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.THUOC} isReturn={false} />,
        },
        {
            eventKey: '1',
            title: 'Vật tư',
            component: <ThuocVatTuDetail generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.VAT_TU} isReturn={false} />,
        },
        {
            eventKey: '2',
            title: 'Thuốc hoàn trả',
            component: <ThuocVatTuDetail generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.THUOC} isReturn={true} />,
        },
        {
            eventKey: '3',
            title: 'Vật tư hoàn trả',
            component: <ThuocVatTuDetail generalInfo={generalInfo} orderTypeId={ORDER_TYPE_ID.VAT_TU} isReturn={true} />,
        },
    ];

    return (
        <Modal
            show={true}
            onHide={handleClose}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Thuốc/vật tư tiêu hao
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='spaces h-calc-vh-185'>
                <div className='spaces ml-12'>
                    <Form>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            label="Chi tiết đơn thuốc/vật tư"
                            checked={isDetail}
                            onChange={() => setIsDetail(!isDetail)}
                        />
                    </Form>
                </div>
                <CustomTabMenu
                    danhsachTabs={isDetail ? DETAIL_TABS : GENERAL_TABS}
                />
            </Modal.Body>
        </Modal>
    )
}

export default ModalThuocVatTuTieuHao

const ThuocVatTu = ({ generalInfo, orderTypeId, isReturn }: any) => {
    const [dsThuocVatTu, setDsThuocVatTu] = useState<any[]>([]);

    const handleGetDsThuocVatTu = async () => {
        try {
            let data = await getDsThuocVatTuDVKT(generalInfo?.orderId, isReturn);
            if (CODE.SUCCESS === data?.code) {
                let convertedData = data?.data?.map((item: any) => {
                    return {
                        name: item?.name,
                        subs: item?.groups?.map((item: any) => ({
                            ...item,
                            name: `Đơn: ${item?.code}`,
                            subs: item?.lstMedicalItemOrderRes
                        })),
                    }
                })
                setDsThuocVatTu(convertedData);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        handleGetDsThuocVatTu();
    }, []);

    return (
        <TableCollapseCustom
            columns={thuocVatTuColumn}
            data={dsThuocVatTu || []}
            className="overflow-auto spaces h-calc-vh-265 mt-7"
            classNameTable="spaces W-1000"
            childrenField="subs"
        />
    )
}

const ThuocVatTuDetail = ({ generalInfo, orderTypeId, isReturn }: any) => {

    const [dsPhieu, setDsPhieu] = useState<any[]>([]);
    const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
    const [donThuocInfo, setDonThuocInfo] = useState<any>(null);

    const formatDateField = (value: any) => {
        return value ? formatDateTime(value, APP_DATE_TIME_FORMAT) : '...';
    };

    const handleGetDsPhieu = async () => {
        try {
            let data = await getDonThuocDVKT(generalInfo?.orderId, orderTypeId, isReturn);
            if (CODE.SUCCESS === data?.code) {
                let dsPhieuConverted = data?.data?.map((item: any) => {
                    return {
                        ...item,
                        date: moment(item?.doctorOrderDay).format("DD/MM/YYYY"),
                    };
                });
                setDsPhieu(dsPhieuConverted || []);
                setSelectedPhieu(null);
            } else {
                setDsPhieu([]);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSelectPhieu = async (id: any) => {
        try {
            let data = await getDetailDonThuoc(id);
            if (CODE.SUCCESS === data?.code) {
                setDonThuocInfo(data?.data);
            } else {
                setDsPhieu([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (selectedPhieu?.id) {
            handleSelectPhieu(selectedPhieu?.id);
        } else {
            setDonThuocInfo(null);
        }
    }, [selectedPhieu]);

    useEffect(() => {
        handleGetDsPhieu();
    }, []);

    return (
        <Row className="h-100 spaces px-16 py-5">
            <div>
                <div className="px-3 py-1 bg-white border-bottom border-bottom-2">
                    <Row>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Loại phiếu:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.type || (donThuocInfo?.id && 'Phiếu chỉ định') || '...'}
                            </span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Ngày y lệnh:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {formatDateField(donThuocInfo?.doctorOrderDay)}
                            </span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Ngày chỉ định:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {formatDateField(donThuocInfo?.designatedDate)}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Mã phiếu:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">{donThuocInfo?.code || '...'}</span>
                        </Col>
                        <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Nơi chỉ định:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.designatedPlace || '...'}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Người chỉ định:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.designatedPerson || '...'}
                            </span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Trạng thái:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.statusName || '...'}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Kho:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.warehouseName || '...'}
                            </span>
                        </Col>
                        <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Chẩn đoán:" className="spaces min-w-110" />
                            <span className="fw-light text-truncate">
                                {donThuocInfo?.provisionalDiagnosisName || '...'}
                            </span>
                        </Col>
                    </Row>
                </div>
                <div className="px-10 py-5 spaces mb-4">
                    <InputSearch
                        value={""}
                        placeholder="Tìm kiếm"
                        handleChange={() => { }}
                        className="spaces h-25 radius-3"
                    />
                </div>
                <div className="px-7 spaces pb-4">
                    <DanhSachPhieu
                        dsPhieu={dsPhieu || []}
                        handleSelectRowData={(data) => setSelectedPhieu(data)}
                        title="price"
                        isGetFirstData
                    />
                </div>
                <div className='spaces h-calc-vh-525'>
                    <TableCustom<any>
                        className="overflow-auto"
                        data={donThuocInfo?.lstMedicalItemOrderRes?.map((row: any) => ({
                            ...row,
                            ...(orderTypeId === ORDER_TYPE_ID.VAT_TU && {
                                maVatTu: row.medicalItemCode,
                                tenVatTu: row.name,
                                donVi: row.unit,
                                soLuong: row.totalQuantity,
                                donGia: row.unitPrice,
                                thanhTien: row.intoMoney,
                            }),
                        })) || []}
                        columns={TYPE[orderTypeId].columns}
                    />
                </div>
                <ThaoTac
                    donThuocInfo={donThuocInfo}
                    getDanhSachDonThuoc={handleGetDsPhieu}
                    handleSelectPhieu={handleSelectPhieu}
                    generalInfo={generalInfo}
                    isThuoc={orderTypeId === ORDER_TYPE_ID.THUOC}
                    isReturn={isReturn}
                />
            </div>
        </Row>
    );
};

const ThaoTac = ({ donThuocInfo, getDanhSachDonThuoc, handleSelectPhieu, generalInfo, isThuoc, isReturn }: {
    getDanhSachDonThuoc: () => void;
    donThuocInfo: any;
    handleSelectPhieu: (id: number | string) => void;
    generalInfo: any;
    isThuoc: boolean;
    isReturn?: boolean;
}) => {

    const [guiDonThuoc, setGuiDonThuoc] = useState<boolean>();
    const [openDonThuocDialog, setOpenDonThuocDialog] = useState(false);
    const [openDonVatTuDialog, setOpenDonVatTuDialog] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [keyOpenPhieuIn, setKeyOpenPhieuIn] = useState<string>('');
    const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);

    const isXuatKho = [
        WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHO_XUAT_KHO,
        WORKFLOW_MEDICAL_ITEM_STATUS_CODE.DA_XUAT_KHO,
    ].includes(donThuocInfo?.statusCode);

    const onDeleteDonThuoc = async () => {
        try {
            const response = await deleteDonThuoc(donThuocInfo.id);
            if (CODE.SUCCESS === response.code) {
                toast.success(RESPONSE_MESSAGE.DELETE.SUCCESS);
                setOpenConfirmDialog(false);
                getDanhSachDonThuoc();
                // statusChangedEventFunc?.();
            } else {
                let errorMessage = response?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
                toast.warn(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    };

    const handlePressKeyShortcuts = (e: any) => {
        switch (e.key) {
            case KEY.F3:
                e.preventDefault();
                setKeyOpenPhieuIn('F3');
                break;
            default:
                return;
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handlePressKeyShortcuts);
        return () => {
            window.removeEventListener('keydown', handlePressKeyShortcuts);
        };
    }, []);

    useEffect(() => {
        setGuiDonThuoc(donThuocInfo?.statusCode === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
    }, [donThuocInfo?.statusCode]);

    const PrintButton = () => {
        return (
            <ButtonInPhieu<IInPhieuChiDinhThuocParams>
                fetchExport={printPhieuChiDinhThuoc}
                params={{
                    fileType: 'pdf',
                    patientId: generalInfo?.patient?.id,
                    medicalItemGroupId: donThuocInfo.id,
                    visitId: generalInfo?.visit?.id,
                    type: parseInt(isThuoc ? ORDER_TYPE_ID.THUOC : ORDER_TYPE_ID.VAT_TU),
                }}
                label={`In đơn ${isThuoc ? 'thuốc' : 'vật tư'} (F3)`}
                className="btn-fill"
                keyOpenPhieuIn={keyOpenPhieuIn}
                setKeyOpenPhieuIn={setKeyOpenPhieuIn}
                keyBtn={KEY.F3}
            />
        );
    };

    const WorkFlowButton = () => {
        return (
            <WfButton
                tracker={WfConstTrackerClinical.MEDICAL_ITEMS}
                objectId={donThuocInfo?.id}
                prefixFunction={(statusCode: string, callbackFn: () => any, cancel?: () => void) => {
                    if (WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHUA_GUI_DON === statusCode) {
                        onGuiDonThuoc(callbackFn, cancel)
                        return;
                    }

                    onHuyGuiDonThuoc(callbackFn, cancel);
                }}
                additionalFunc={(status: any) => {
                    onUpdateWorkflowStatus(status);
                }}
                forceRender={isUpdateWorkflow}
            ></WfButton>
        );
    };

const onGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
        try {
            const { code, data } = await saveDonThuocDVKT({
                ...donThuocInfo,
                encounterId: donThuocInfo?.encounterId,
                orderTypeId: parseInt(ORDER_TYPE_ID.THUOC),
                orderId: generalInfo?.orderId,
                lstMedicalItemOrder: donThuocInfo?.lstMedicalItemOrderRes,
                birthDay: getBirthdayDrugParam(generalInfo?.patient),
                formCode: isReturn ? REQUEST_FROM.HOAN_TRA : REQUEST_FROM.HAO_PHI,
                medicalItemTypeCode: isThuoc ? REQUEST_TYPE.THUOC : REQUEST_TYPE.VAT_TU,
                visitObjectTypeCode: generalInfo?.visit?.visitObjectTypeCode
            }, null, generalInfo?.orderId, isReturn);
            if (CODE.SUCCESS === code) {
                toast.success(`Gửi đơn ${isThuoc ? 'thuốc' : 'vật tư'} thành công`);
                callbackFn();
            } else {
                toast.error(getErrorMessage({ code, data }));
                cancel?.();
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
            cancel?.();
        }
    };

    const onHuyGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
        try {
            const { code } = await huyGuiDonThuoc(donThuocInfo?.id);
            if (CODE.SUCCESS === code) {
                toast.success(`Huỷ gửi đơn ${isThuoc ? 'thuốc' : 'vật tư'} thành công`);
                callbackFn();
            } else {
                cancel?.();
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
            cancel?.();
        }
    };

    const onUpdateWorkflowStatus = (workflowStatus: string) => {
        setGuiDonThuoc(workflowStatus === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
        handleSelectPhieu(donThuocInfo?.id);
    };

    if (!donThuocInfo?.id) return <div className="bg-white spaces min-h-50"></div>;

    if (isXuatKho) return <div className="d-flex gap-3 bg-white p-2">{PrintButton()}</div>;

    return (
        <div className="d-flex gap-3 justify-content-start p-2 bg-white">
            {guiDonThuoc ? (
                <>
                    {PrintButton()}
                    {donThuocInfo?.isAllowModify && WorkFlowButton()}
                </>
            ) : <>
                {
                    donThuocInfo?.isAllowModify && <>
                        <Button
                            className="btn-navy-outlined mr-5"
                            onClick={() => isThuoc ? setOpenDonThuocDialog(true) : setOpenDonVatTuDialog(true)}
                        >
                                {`Sửa đơn ${isThuoc ? 'thuốc' : 'vật tư'}`}
                        </Button>
                        {WorkFlowButton()}
                        <Button
                            className="btn-secondary mr-5"
                            onClick={() => setOpenConfirmDialog(true)}
                        >
                            {`Xóa ${isThuoc ? 'thuốc' : 'vật tư'}`}
                        </Button>
                    </>
                }
            </>}

            {openDonThuocDialog && (
                <PageKeThuoc
                    open={openDonThuocDialog}
                    handleClose={() => {
                        setOpenDonThuocDialog(false);
                    }}
                    itemEdit={donThuocInfo}
                    onSave={() => {
                        setOpenDonThuocDialog(false);
                        setIsUpdateWorkflow(!isUpdateWorkflow);
                        handleSelectPhieu(donThuocInfo?.id);
                    }}
                    generalInfo={generalInfo}
                />
            )}

            {openDonVatTuDialog && (
                <ModalKeVatTu
                    open={openDonVatTuDialog}
                    handleClose={() => {
                        setOpenDonVatTuDialog(false);
                    }}
                    itemEdit={donThuocInfo}
                    onSave={() => {
                        setOpenDonVatTuDialog(false);
                        setIsUpdateWorkflow(!isUpdateWorkflow);
                        handleSelectPhieu(donThuocInfo?.id);
                    }}
                    generalInfo={generalInfo}
                />
            )}

            {openConfirmDialog && (
                <ConfirmDialog
                    className="z-index-1060"
                    show={openConfirmDialog}
                    title="Thông báo"
                    message={`Bạn có chắc chắn muốn xóa đơn ${isThuoc ? 'thuốc' : 'vật tư'} này không ?`}
                    yes="Xác nhận"
                    close="Đóng"
                    onCloseClick={() => {
                        setOpenConfirmDialog(false);
                    }}
                    onYesClick={onDeleteDonThuoc}
                />
            )}
        </div>
    );
};